import React from 'react';

import { StyledButton } from './styles';

const InPageFeaturesCtaButton = ({ to }) => (
  <StyledButton color="blue" to={to}>
    <p>Learn More</p>
  </StyledButton>
);

export default InPageFeaturesCtaButton;
